import script from "./ProveedorTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProveedorTable.vue?vue&type=script&setup=true&lang=ts"

import "./ProveedorTable.vue?vue&type=style&index=0&id=2f394db7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f394db7"]])

export default __exports__